export const formatCurrency = (cents: number, showSign = false): string => {
  const sign = showSign && cents > 0 ? "+" : "";
  return `${sign}¥${(cents / 100).toLocaleString("zh-CN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const yuanToCents = (value: string): number | null => {
  const normalized = value.trim();
  if (!/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(normalized)) return null;
  const [yuan, fraction = ""] = normalized.split(".");
  const cents = Number(yuan) * 100 + Number(fraction.padEnd(2, "0"));
  return Number.isSafeInteger(cents) && cents > 0 ? cents : null;
};

export const centsToInput = (cents: number): string => (cents / 100).toFixed(2);
